import Vue from 'vue';

export const GlobalStore = Vue.observable({
  user: {
    customerNumber: null,
    isLoggedIn: false,
    isPartner: false,
    raw: null,
  },
});
